import React from 'react';
import { Box } from 'edenred-ui';

import { AcceptTermsCheckbox } from '@epi-forms/controls';

import './TermsAndConditions.scss';

export function TermsAndConditions() {
  return (
    <Box pl={3} id="TermsAndConditions">
      <AcceptTermsCheckbox />
    </Box>
  );
}
